<template>
    <div>
        <div v-if="$vuetify.breakpoint.mobile">
            <div v-for="item in items" :key="item.id" class="z-clickable" @click="showActivity(item)">
                <div class="d-flex pa-2">
                    <v-sheet width="20" height="20" :color="item.color || 'white'" />
                    <div class="ml-2 d-flex fill-width">
                        <div class="z-half">{{item.activity}}</div>
                        <div class="z-half text-align-right">{{item.start}}</div>
                    </div>
                </div>
                <hr class="v-divider theme--light flex-grow-1 mt-1" />
            </div>
        </div>

        <v-data-table
            v-else
            :headers="headers"
            :items="items"
            item-key="id"
            hide-default-footer
            :items-per-page="-1"
            @click:row="showActivity"
            class="z-clickable"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
        >
            <template v-slot:item.activity="{ item }">
                <div class="d-flex">
                    <v-sheet width="20" height="20" :color="item.color || 'white'" />
                    <div class="ml-2">{{item.activity}}</div>
                </div>
            </template>

             <template v-slot:item.start="{ item }">
                <div class="d-flex">
                    <div v-for="(part,index) in item.time" :key="index" class="mr-2">
                        {{part}}
                    </div>
                </div>
            </template>

        </v-data-table>
        <workout-dialog v-model="showWorkoutDialog" :workout="showingWorkout" v-if="showWorkoutDialog" />
        <resource-booking-dialog v-model="showResourceBookingDialog" :booking="showingResourceBooking" v-if="showResourceBookingDialog" />
    </div>
</template>

<script>
import WorkoutDialog from '../components/WorkoutDialog.vue'
import ResourceBookingDialog from '../components/ResourceBookingDialog.vue'
export default {
    name: 'zoezi-historical-bookings',

    props: {
        fromDate: {},
        toDate: {}
    },

    components: {
        WorkoutDialog,
        ResourceBookingDialog
    },

    computed: {
        bookingsArgs() {
            return {
                startTime: Date.newFull(this.fromDate).yyyymmdd(),
                endTime: Date.newFull(this.toDate).yyyymmdd()
            }
        },
        headers() {
            return [
                {text: 'Activity', value: 'activity'},
                {text: 'Time', value: 'start'}
            ].map(x => {
                x.text = this.$translate(x.text);
                return x;
            })
        },
        items() {
            let res = [];

            this.bookings.workouts.forEach(wb => {
                res.push({
                    id: wb.id,
                    type: 'workout',
                    activity: wb.workoutType.name,
                    time: [
                        Date.newFull(wb.startTime).yyyymmdd(),
                        this.$translate(Date.newFull(wb.startTime).getWeekDayString()),
                        Date.newFull(wb.startTime).hhmm(),
                        '-',
                        Date.newFull(wb.endTime).hhmm()
                    ],
                    start: Date.newFull(wb.startTime).dateTime(),
                    color: wb.workoutType.color
                });
            });

            let rbs = [];
            this.bookings.resourcebookings?.forEach(rcat => {
                rbs = rbs.concat(rcat.bookings.filter(rb => !rb.cancelled));
            })

            rbs.forEach(rb => {
                res.push({
                    id: rb.id,
                    type: 'resourcebooking',
                    activity: rb.servicename,
                    time: [
                        Date.newFull(rb.time).yyyymmdd(),
                        this.$translate(Date.newFull(rb.time).getWeekDayString()),
                        Date.newFull(rb.time).hhmm(),
                        '-',
                        Date.newFull(rb.time).addMinutes(rb.duration).hhmm()
                    ],
                    start: Date.newFull(rb.time).dateTime(),
                    rb: rb
                });
            });

            res.sort((a,b) => Date.newFull(b.start).getTime() - Date.newFull(a.start).getTime());

            return res;
        }
    },

    watch: {
        bookingsArgs: {
            immediate: true,
            handler() {
                this.loadBookings();
            }
        }
    },

    data: () => ({
        sortBy: 'start',
        sortDesc: true,
        bookings: {
            workouts: [],
            resourcebookings: []
        },
        showWorkoutDialog: false,
        showingWorkout: null,
        showResourceBookingDialog: false,
        showingResourceBooking: null
    }),

    methods: {
        loadBookings() {
            this.$api.get('/api/memberapi/bookings/get', this.bookingsArgs).then(x => {
                this.bookings = x;
            });
        },
        showActivity(booking) {
            if (booking.type == 'workout') {
                this.$api.get('/api/memberapi/workout/get', {id: booking.id}).then(x => {
                    this.$booking.transformWorkout(x);
                    this.showWorkoutDialog = true;
                    this.showingWorkout = x;
                }).catch(() => {
                    this.$store.commit('showErrorDialog', {title: this.$translate('Error displaying booking'), text: this.$translate('It was not possible to display the booking')})
                })
            } else if (booking.type == 'resourcebooking') {
                this.showingResourceBooking = booking.rb;
                this.showResourceBookingDialog = true;
            }
        }
    }
}
</script>